import React from "react";
import { useDispatch, useSelector } from "react-redux";
import TheHeader from "./comm/TheHeader";
import {
  CButton,
  CFormGroup,
  CCol,
  CCardBody,
  CInputGroup,
  CLabel,
  CForm,
  CInputFile,
  CInput,
  CContainer,
  CInputGroupAppend,
  CListGroup,
  CListGroupItem,
} from "@coreui/react";
import CIcon from "@coreui/icons-react";
import TheNav from "./comm/TheNav";
import TheFooter from "./comm/TheFooter";
import ShowImgPop from "./showImgPop";
import ApiHelper from "src/utils/api/api_helper";
import {
  initSbmsDocFile,
  deleteHasBlankFile,
  deletePrevSbmsDocFile,
  deleteSbmsDocFile,
  changeSbmsDocFile,
  setIsFirstTrue,
  setModifySbmsDocFile,
  setSbmsDocFile,
  setSbmsDocFileInfo,
  setUpdateFalse,
  clearDeleteFiles,
} from "../../modules/sbmsDoc";
import Swal from "sweetalert";
import { useHistory, useLocation } from "react-router-dom";

const SbmsDocPage = () => {
  const { sbmsDoc, main, insert } = useSelector((state) => state);
  const dispatch = useDispatch();
  const history = useHistory();
  const corpNm = useLocation().pathname.split('/')[1];
  const pathParam = Number(useLocation().pathname.split('/')[2]);
  const [isIng, setIsIng] = React.useState(false);
  const [sbmsDocList, setSbmsDocList] = React.useState([]);
  const [showImgPop, setShowImgPop] = React.useState({
    isOpen: false,
    docNo: "",
  });
  const [saveYn, setSaveYn] = React.useState(false);

  const handleOnClick = (e) => {
    e.stopPropagation();
    let event;
    var agent = navigator.userAgent.toLowerCase();
    if (
      (navigator.appName === "Netscape" && agent.indexOf("trident") !== -1) ||
      agent.indexOf("msie") !== -1
    ) {
      // ie일 경우
      event = document.createEvent("Event");
      event.initEvent("click", true, true);
    } else {
      // ie가 아닐 경우
      event = new MouseEvent("click", {
        view: window,
        bubbles: true,
        cancelable: true,
      });
    }

    document
      .getElementById(`file${e.target.dataset.sbmsdocno}`)
      .dispatchEvent(event);
  };

  const handleOnChange = async (e) => {
    let fail = false;
    const changeData = [];
    const files = [];
    const fileInfoList = [];
    const {sbmsDocFiles} = sbmsDoc;
    const {name} = e.target;
    const checkFileDataArr = sbmsDocFiles.filter((item) => String(item.name) === String(name));
    const newFileInfo = checkFileDataArr[0].fileInfo;
    const docNo = checkFileDataArr[0].docNo;

    await dispatch(changeSbmsDocFile(docNo));

    for (let item of e.target.files) {
      const LIMIT = 20 * 1024 * 1024;

      if (
        item.type === "image/png" ||
        item.type === "image/jpeg" ||
        item.type === "image/gif"
      ) {
        if (item.size >= LIMIT)
          return Swal(
            "파일추가",
            "20MB가 넘는 파일은 첨부할 수 없습니다.",
            "error"
          );

        for(let i = 0; i < newFileInfo.length; i++) {
          if(item.name === newFileInfo[i].fileNm ) {
            fail = true;
            return Swal("파일중복", "동일한 파일명이 이미 존재합니다.", "info");
          }
        }

        if(fail) return;

        files.push(item);
        fileInfoList.push({
          seqNo: "",
          fileNm: item.name,
          realFileNm: "",
          midPath:"",
        });
      } else {
        return Swal(
          "파일추가",
          "png, gif, jpeg 파일만 업로드가 가능합니다.",
          "error"
        );
      }
    }

    changeData.push({
      SBMS_DOC_NO: e.target.dataset.docNo,
      FILE: files,
      FILE_INFO: fileInfoList,
    });

    await dispatch(setModifySbmsDocFile(changeData, false));
    await setSaveYn(true);
  };

  const handelDeleteFile = (e) => {
    e.stopPropagation();
    const fileSeqNo = e.target.dataset.seqNo;
    const index = e.target.dataset.index;
    const docNo = e.target.dataset.docNo;
    const fileNm = e.target.dataset.fileNm;

    if (fileSeqNo !== "") {
      dispatch(deletePrevSbmsDocFile(index, fileSeqNo, docNo));
    } else {
      const delSbmsDocFile = {
        index,
        docNo,
        fileInfo: { seqNo: "", fileNm },
      };
      
      dispatch(deleteSbmsDocFile(delSbmsDocFile));
      
      // const id = e.target.dataset.id;
      // let fileBuffer = [];

      // Array.prototype.push.apply(fileBuffer, document.querySelector(`input[name="doc${docNo}"]`).files);
      // fileBuffer.forEach((item, index) => {
      //   if(item.name === fileNm) fileBuffer.splice(index, 1);
      // });

      // const dataTranster = new DataTransfer();

      // Array.from(document.querySelector(`input[name="doc${docNo}"]`).files)
      // .filter(file => (String(file.name) != String(fileNm) && String(file.lastModified) != String(id)))
      // .forEach(file => {
      //   dataTranster.items.add(file);
      // });

      // document.querySelector(`input[name="doc${docNo}"]`).files = dataTranster.files;
    }

    document.querySelector(`input[name="doc${docNo}"]`).value = '';
  };

  const handleShowImages = (e) => {
    const docNo = e.target.dataset.docNo;
    const target = document.getElementById(`file${docNo}`);

    if (target.nextSibling == null)
      return Swal("추가서류", `등록된 파일이 없습니다.`, "info");

    setShowImgPop({ isOpen: true, docNo: e.target.dataset.docNo });
  };

  const handleUpload = (e, nextPage) => {
    let formData = new FormData();
    let docNoList = [];
    let delFileSeqNoList = sbmsDoc.deleteFiles;
    let index = 1;
    
    formData.append("type", "SBMS_DOC");
    formData.append("reqNo", insert.reqTaskInfo.reqNo);
    formData.append("corpNm", main.corpNm);
    formData.append("delSeqNoList", JSON.stringify(delFileSeqNoList));
    
    sbmsDoc.sbmsDocFiles.forEach((docFile) => {
      if (docFile.update) {
        docFile.file.forEach((file) => {
          docFile.file && formData.append(`doc${index}`, file);
        });
        docFile.file.length > 0 && docNoList.push(docFile.docNo);
        
        if(docFile.file.length > 0) index++;
      }
    });
    
    formData.append("docNoList", JSON.stringify(docNoList));

    if (nextPage) {
      let _sbmsDocFiles = sbmsDoc.sbmsDocFiles.filter(
        (item) => item.ncryYn === "1"
      );

      for (let checkItem of _sbmsDocFiles) {
        if (checkItem.fileInfo.length <= 0) {
          return Swal(
            "추가서류",
            `${checkItem.docNm} 파일이 등록되지 않았습니다.`,
            "error"
          );
        }
      }
    }

    if (isIng) {
      console.log("save images are excuting...");
      return Swal(
        "저장중...",
        `파일들을 저장중입니다. 잠시만 기다려주세요.`,
        "info"
      );
    }
    setIsIng(true);

    ApiHelper.request(
      ApiHelper.methods.post,
      "/cust/request/tempSaveStep6",
      formData
    )
      .then(({ data }) => {
        setIsIng(false);
        if (data.status === "SUCCESS") {
          dispatch(clearDeleteFiles());
          dispatch(setUpdateFalse());
          if (nextPage) {
            dispatch(setIsFirstTrue());
            history.push(`/${corpNm}/${pathParam + 1}`);
          } else {
            dispatch(initSbmsDocFile());
            dispatch(setSbmsDocFileInfo(data.data));
            if(!saveYn){
              return Swal("", "임시저장 되었습니다.", "success");
            }
          }
        }
        if (data.status === "ERROR") {
          const errFileNm = data.data.originalname;
          const errMsg = `파일명: ${errFileNm}`;

          return Swal("파일형식오류", errMsg, "info");
        }
      })
      .catch((err) => {
        console.error(err);
      });
  };

  // 파일 업로드 시 바로 서버에 저장
  React.useEffect(async () => {
    if(saveYn){
      handleUpload("", false);
      setSaveYn(false);
    }
  }, [saveYn]);

  const param = {
    taskNo: main.taskNo,
    reqNo: insert.reqTaskInfo.reqNo,
  };

  React.useEffect(() => {
    const getInitData = async () => {
      await ApiHelper.request(
        ApiHelper.methods.post,
        "/cust/request/sbmsDocList",
        param
      )
        .then(({ data }) => {
          if (data.status === "SUCCESS") {
            let result = data.data;
            setSbmsDocList(result);

            if (result.length) {
              let initData = [];
              result.forEach((item) => {
                initData.push({
                  name: `doc${item.SBMS_DOC_NO}`,
                  docNo: item.SBMS_DOC_NO,
                  docNm: item.SBMS_DOC_NM,
                  midPath: item.MID_PATH,
                  file: [],
                  fileInfo: [],
                  ncryYn: item.NCRY_YN,
                  update: false,
                });
              });

              dispatch(setSbmsDocFile(initData));
            }
          }
        })
        .catch((err) => {
          console.error(err);
        });

      // 3개월 초과된 파일 삭제(메가인포 제외)
      if(main.corpNo != '45'){
        await ApiHelper.request(
          ApiHelper.methods.post,
          "/cust/request/sbmsDocExprInfo",
          {
            reqNo: insert.reqTaskInfo.reqNo,
          }
        )
          .then(({ data }) => {
            if (data.status === "SUCCESS") {
              let result = data.data;
  
              if(result !== "N"){
                Swal("파일재확인", "업로드 후 3개월이 초과되어 삭제 된 파일은 재업로드 후 진행해주세요.", "warning");
              }
            }
          })
          .catch((err) => {
            console.error(err);
          });
      }

      await ApiHelper.request(
        ApiHelper.methods.post,
        "/cust/request/sbmsDocInfo",
        {
          reqNo: insert.reqTaskInfo.reqNo,
        }
      )
        .then(({ data }) => {
          if (data.status === "SUCCESS") {
            let result = data.data;
            let gotData = [];
            let existDocData = [];
            let fileInfoArr = [];

            if (result.length) {
              result.forEach((sbmsDocFile) => {
                existDocData = result.filter(
                  (item) => sbmsDocFile.SBMS_DOC_NO === item.SBMS_DOC_NO
                );
                if (existDocData.length) {
                  for (let data of existDocData) {
                    fileInfoArr.push({
                      seqNo: data.SEQ_NO,
                      fileNm: data.UPLD_FILE_NM,
                      realFileNm: data.REAL_FILE_NM,
                      midPath: data.MID_PATH
                    });
                  }
                }

                gotData.push({
                  SBMS_DOC_NO: sbmsDocFile.SBMS_DOC_NO,
                  FILE: [],
                  FILE_INFO: fileInfoArr,
                });

                fileInfoArr = [];
              });

              gotData = gotData.reduce(function (acc, current) {
                if (
                  acc.findIndex(
                    ({ SBMS_DOC_NO }) => SBMS_DOC_NO === current.SBMS_DOC_NO
                  ) === -1
                ) {
                  acc.push(current);
                }
                return acc;
              }, []);
            }
            dispatch(setModifySbmsDocFile(gotData, true));
          }
        })
        .catch((err) => {
          console.error(err);
        });
    };

    if (sbmsDoc.isFirst) {
      getInitData();
    } else {
      ApiHelper.request(
        ApiHelper.methods.post,
        "/cust/request/sbmsDocList",
        param
      )
        .then(({ data }) => {
          if (data.status === "SUCCESS") {
            let result = data.data;

            setSbmsDocList(result);
          }
        })
        .catch((err) => {
          console.error(err);
        });

      dispatch(deleteHasBlankFile());
    }
  }, []);

  return (
    <>
      <TheHeader />
      <div className="c-main">
        <TheNav step={main.step} />
        <CContainer className="text-left">
          <h5>
            <b>
              {main.cntrYn !== "0" && "위촉계약서 및 "}보험사별 위촉서류
              처리를 위한 추가서류를 제출합니다.
            </b>
          </h5>
          <span className="subSpan">
            <h6>
              <b>
                제출가능한 사진파일의 확장자는 PNG, JP(E)G, GIF이며, 파일 하나의
                최대용량은 20MB입니다.
              </b>
            </h6>
          </span>
        </CContainer>
        <CCardBody className="bottom-card-body">
          <CForm>
            {sbmsDocList.length > 0 ? (
              sbmsDocList.map((item, index) => {
                return (
                  <CFormGroup row key={item.SBMS_DOC_NO}>
                    <CCol xs="10" className="text-left">
                      <CLabel htmlFor="name-input">
                        {item.SBMS_DOC_NM}
                        {Number(item.NCRY_YN) ? (
                          <span>&#40;필수&#41;</span>
                        ) : undefined}
                      </CLabel>
                    </CCol>
                    <CCol xs="2" className="text-right">
                      <CButton
                        size="sm"
                        color="link"
                        data-doc-no={item.SBMS_DOC_NO}
                        onClick={handleShowImages}
                      >
                        <b className="doNotTarget">미리보기</b>
                      </CButton>
                    </CCol>
                    <CCol xs="12" className="mb-2">
                      <CButton
                        block
                        color="primary"
                        variant="outline"
                        className="m-0 p-0"
                        data-sbmsdocno={item.SBMS_DOC_NO}
                        onClick={handleOnClick}
                        disabled={
                          insert.reqTaskInfo.stCd === "10" ||
                          insert.reqTaskInfo.stCd === "99"
                            ? false
                            : true
                        }
                      >
                        파일찾기
                        <CIcon name="cilLibraryAdd" alt="iocn" size="lg" />
                      </CButton>
                    </CCol>
                    <CCol xs="12">
                      <CInputFile
                        className="file"
                        name={`doc${item.SBMS_DOC_NO}`}
                        data-doc-nm={item.SBMS_DOC_NM}
                        data-doc-no={item.SBMS_DOC_NO}
                        id={`file${item.SBMS_DOC_NO}`}
                        onChange={handleOnChange}
                        multiple
                      />
                      {sbmsDoc.sbmsDocFiles[index] &&
                        sbmsDoc.sbmsDocFiles[index].fileInfo.map(
                          (fileData, index) => {
                            let addClassNm = "";

                            for (let i of sbmsDoc.deleteFiles) {
                              if (Number(i) === Number(fileData.seqNo)) {
                                addClassNm = "delSeqNo";
                              }
                            }

                            return (
                              <CInputGroup
                                key={index}
                                className={`mb-1 ${addClassNm}`}
                              >
                                <CInput
                                  type="text"
                                  className="inputPx"
                                  value={fileData.fileNm}
                                  readOnly
                                />
                                <CInputGroupAppend>
                                  <CButton
                                    color="Light"
                                    variant="outline"
                                    className="p-0 m-0"
                                    data-index={index}
                                    data-doc-no={item.SBMS_DOC_NO}
                                    data-file-nm={fileData.fileNm}
                                    data-seq-no={fileData.seqNo}
                                    onClick={handelDeleteFile}
                                    disabled={
                                      insert.reqTaskInfo.stCd === "10" ||
                                      insert.reqTaskInfo.stCd === "99"
                                        ? false
                                        : true
                                    }
                                  >
                                    <CIcon
                                      name="cilDelete"
                                      alt="iocn"
                                      size="lg"
                                      className="m-0 p-0"
                                    />
                                  </CButton>
                                </CInputGroupAppend>
                              </CInputGroup>
                            );
                          }
                        )}
                    </CCol>
                  </CFormGroup>
                );
              })
            ) : (
              <CListGroup>
                <CListGroupItem className="infoListItem">
                  해당업무에는 추가로 제출할 서류가 없습니다.
                </CListGroupItem>
              </CListGroup>
            )}
          </CForm>
        </CCardBody>
      </div>
      <TheFooter step={main.step} handleUpload={handleUpload} />
      {showImgPop.isOpen && (
        <ShowImgPop
          modal={true}
          docNo={showImgPop.docNo}
          onClose={() => setShowImgPop({ isOpen: false })}
        ></ShowImgPop>
      )}
    </>
  );
};

export default SbmsDocPage;
